import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { useFeatureToggle } from '~/platform/utilities/feature-toggles';
import {
  API_ROUTES,
  FIELD_NAMES,
} from 'platform/user/profile/vap-svc/constants';
import { addressConvertCleanDataToPayload } from 'platform/user/profile/vap-svc/util/contact-information/addressUtils';

import VAPServiceProfileField from '~/platform/user/profile/vap-svc/containers/VAPServiceProfileField';
import ProfileField from '~/platform/user/profile/vap-svc/containers/ProfileField';

import AddressView from './AddressView';

import { getFormSchema, getUiSchema } from './address-schemas';

function AddressField({ title, fieldName, deleteDisabled }) {
  const useUnicodeAddressValidation = useSelector(
    state =>
      state.featureToggles?.profileInternationalAddressValidationEnabled ||
      false,
  );

  const { useToggleValue, TOGGLE_NAMES } = useFeatureToggle();
  const isProfileServiceRefactorEnabled = useToggleValue(
    TOGGLE_NAMES.cveProfileServiceRefactor,
  );

  // Feature-flag switch between the legacy class-based container
  // (VAPServiceProfileField) and the refactored hooks-based container
  // (ProfileField). Both accept the same props.
  const ProfileFieldComponent = isProfileServiceRefactorEnabled
    ? ProfileField
    : VAPServiceProfileField;

  return (
    <ProfileFieldComponent
      title={title}
      fieldName={fieldName}
      apiRoute={API_ROUTES.ADDRESSES}
      convertCleanDataToPayload={addressConvertCleanDataToPayload}
      deleteDisabled={deleteDisabled}
      Content={AddressView}
      formSchema={getFormSchema()}
      uiSchema={getUiSchema(useUnicodeAddressValidation)}
    />
  );
}

AddressField.propTypes = {
  fieldName: PropTypes.oneOf([
    FIELD_NAMES.MAILING_ADDRESS,
    FIELD_NAMES.RESIDENTIAL_ADDRESS,
  ]).isRequired,
  title: PropTypes.string.isRequired,
  deleteDisabled: PropTypes.bool,
};

export default AddressField;
